/**
 * Normalizes input URLs, automatically converting standard Google Sheets URLs
 * (edit, view, share, or published links) into direct CORS-friendly CSV export URLs.
 */
export function normalizeCsvUrl(inputUrl: string): string {
  let url = inputUrl.trim();
  if (!url) return url;

  // Google Sheets Published Web URL: https://docs.google.com/spreadsheets/d/e/2PACX-.../pubhtml
  if (url.includes('docs.google.com/spreadsheets/d/e/')) {
    url = url.replace(/\/pubhtml(\?.*)?$/, '/pub?output=csv');
    if (!url.includes('output=csv') && !url.includes('/pub?')) {
      url = url.replace(/\/pub(\?.*)?$/, '/pub?output=csv');
    }
    if (!url.includes('output=csv')) {
      url = url + (url.includes('?') ? '&output=csv' : '?output=csv');
    }
    return url;
  }

  // Google Sheets Standard Sharing URL: https://docs.google.com/spreadsheets/d/{ID}/edit...
  const match = url.match(/docs\.google\.com\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
  if (match && match[1]) {
    const spreadsheetId = match[1];
    let gid = '';
    const gidMatch = url.match(/[?&#]gid=(\d+)/);
    if (gidMatch && gidMatch[1]) {
      gid = gidMatch[1];
    }
    return `https://docs.google.com/spreadsheets/d/${spreadsheetId}/export?format=csv${gid ? `&gid=${gid}` : ''}`;
  }

  return url;
}
